<p-progressSpinner class="soc-manager-spinner spinner-in-front" *ngIf="spinner"></p-progressSpinner>
<div class="div_terms_and_condition" [innerHTML]="TermsAndConditionsText"></div>
